import { i18n }  from  '@euroland/libs';

export default i18n